import DeleteIcon from '@mui/icons-material/Delete'
import { ListItemIcon, ListItemText, MenuItem } from '@mui/material'
import {
  GridColumnMenuContainer,
  GridColumnMenuProps,
} from '@mui/x-data-grid-pro'
import { EditIcon } from 'lucide-react'

interface CustomColumnMenuProps extends GridColumnMenuProps {
  onDeleteRole: (roleId: number) => void
  onEditRole?: (roleId: number) => void
}

export const CustomColumnMenu = (props: CustomColumnMenuProps) => {
  const { hideMenu, currentColumn, onDeleteRole, onEditRole } = props

  const isRoleColumn = currentColumn.field.startsWith('role_')
  const roleId = isRoleColumn
    ? parseInt(currentColumn.field.split('_')[1], 10)
    : null

  const handleDelete = () => {
    if (roleId) {
      onDeleteRole(roleId)
    }
  }

  const handleEdit = (e: React.MouseEvent) => {
    e.stopPropagation()
    hideMenu(e)
    if (roleId && onEditRole) {
      onEditRole(roleId)
    }
  }

  return (
    <GridColumnMenuContainer
      hideMenu={hideMenu}
      currentColumn={currentColumn}
      open={props.open}
      id={props.id}
      labelledby={props.labelledby}
    >
      {isRoleColumn && (
        <MenuItem onClick={handleEdit}>
          <ListItemIcon color="info">
            <EditIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText>Edit Role</ListItemText>
        </MenuItem>
      )}

      {isRoleColumn && (
        <MenuItem onClick={handleDelete} sx={{ color: 'error.main' }}>
          <ListItemIcon>
            <DeleteIcon fontSize="small" color="error" />
          </ListItemIcon>
          <ListItemText>Delete Role</ListItemText>
        </MenuItem>
      )}
    </GridColumnMenuContainer>
  )
}
